<div #editBoxWrapper></div>
<div [innerHTML]="readOnlyContent" *ngIf="readOnly" class="rich-text-read-only"></div>

<form style="display:none">
    <input type="file" #attachmentUploadInput (change)="onSelectAttachment($event)"/>
</form>

<ul class="rich-text-attachments-list" [ngClass]="{'rich-text-attachments-list-read-only': readOnly}"
    *ngIf="attachmentsList.length > 0">
    <li *ngFor="let attachment of attachmentsList" class="rich-text-attachment">
        <a [ngClass]="{'rich-text-attachment-text':!attachment.isFailed,'rich-text-attachment-text-failed':attachment.isFailed}"
           (click)="download(attachment)"
           target="_blank">{{attachment.getAttachmentName()}}</a>
        <dls-icon *ngIf="attachment.isAvailable() && (editable && !readOnly)" (click)="removeAttachment(attachment)"
                  class="pt-icon rich-text-attachment-delete icon-dls-cross-circle"></dls-icon>

        <dls-icon *ngIf="attachment.isFailed" class="pt-icon rich-text-attachment-retry icon__refresh-therapy"
                  (click)="uploadAttachment(attachment)"></dls-icon>

        <dls-progress-circular-indeterminate *ngIf="attachment.isLoading"
                                             class="pt-circular-small">
        </dls-progress-circular-indeterminate>
    </li>
</ul>
